export default class ShoppingCartTravelInsuranceItem {
    constructor(data) {
        Object.defineProperty(this, "offerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "premium", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "provider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "selectionId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.offerId = data.offerId;
        this.premium = data.premium;
        this.provider = data.provider;
        this.selectionId = data.selectionId;
        this.type = 'travel-insurance';
    }
}
